import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'StatusTag',
  props: {
  color: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    required: true,
  },
  text: {
    type: String,
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['status-tag ', __props.color, __props.size])
  }, _toDisplayString(__props.text), 3))
}
}

})